import {
  Component,
  OnInit
} from '@angular/core';

import {
  DomSanitizer,
  SafeResourceUrl
} from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

import {
  AdminService
} from 'src/app/services/admin/admin.service';
import { CourseService } from 'src/app/services/course/course.service';


@Component({
  selector: 'app-admin-xenquiries-component',
  templateUrl: './admin-xenquiries-component.component.html',
  styleUrl: './admin-xenquiries-component.component.scss'
})
export class AdminXEnquiriesComponentComponent implements OnInit {

  // Enquiry list variables
  enquiries: any[] = [];
  totalRecords = 0;
  pageSize = 10;
  pageNo = 1;
  firstRecord = 0;
  isLoading = false;
  errorMessage = '';

  // Filter variables
  selectedApprovalStatus:
    'ALL' | 'APPROVED' | 'PENDING' =
    'ALL';

  selectedActiveStatus:
    'ALL' | 'ACTIVE' | 'INACTIVE' =
    'ALL';

  // Enquiry details modal variables
  showDetailsModal = false;
  selectedEnquiry: any = null;
  selectedEnquiryBody: any = null;

  // Approval variables
  isApprovingEnquiry = false;
  approvalSuccessMessage = '';
  approvalErrorMessage = '';

  // Registration modal variables
  showRegistrationModal = false;
  selectedRegistration: any = null;
  selectedRegistrationEnquiry: any = null;

  selectedEnquiryType: string = "";
  //store   prefix
  ReferencePrefix: string = '';

  todayDate: string = new Date().toISOString().split('T')[0];

  //store enq id
  enqId: number = 0;
  constructor(private route: ActivatedRoute,
    private adminService: AdminService,
    private sanitizer: DomSanitizer, private courseService: CourseService
  ) {
  }



  // Load enquiries on init
  ngOnInit(): void {

    this.loadEnquiries();
    this.getReferencePrefix();
    // read url values
    this.route.queryParamMap.subscribe(params => {

      const id = params.get('id');

      if (id) {

        this.enqId = Number(id);

        if (this.enqId > 0) {
          this.GetXEnquiryById(this.enqId);
        }

      }

    });

  }

  //get prefix
  GetXEnquiryById(enqId: number): void {
    this.courseService.GetXEnquiryById(enqId)
      .subscribe({
        next: (enq: any) => {
          this.openEnquiryDetails(enq);
        },
        error: (error) => {
          console.error(
            'Error loading reference prefix',
            error
          );
        }
      });
  }


  //get prefix
  getReferencePrefix(): void {
    this.courseService.GetReferencePrefix('ENQUIRY')
      .subscribe({
        next: (prefix: string) => {
          this.ReferencePrefix = prefix;
        },
        error: (error) => {
          console.error(
            'Error loading reference prefix',
            error
          );
        }
      });
  }



  // Load enquiry records
  loadEnquiries(): void {

    this.isLoading =
      true;

    this.errorMessage =
      '';

    const isApproved =
      this.getApprovalFilterValue();

    const isActive =
      this.getActiveFilterValue();

    this.adminService
      .getXEnquiryList(
        'GET_ALL_ENQ',
        this.pageNo,
        this.pageSize,
        isApproved,
        isActive,
        this.selectedEnquiryType
      )
      .subscribe({

        next: (response: any) => {

          console.log(
            'Enquiry List:',
            response
          );

          this.enquiries =
            (
              response?.records ||
              []
            )
              .map(
                (item: any) => {

                  return {

                    ...item,

                    parsedBody:
                      this.parseBody(
                        item.body
                      ),

                    parsedRegistrationBody:
                      this.parseBody(
                        item.registrationBody
                      )
                  };
                }
              );

          this.totalRecords =
            response?.totalRecords ||
            0;

          this.isLoading =
            false;
        },

        error: (error) => {

          console.error(
            'Error loading enquiries:',
            error
          );

          this.enquiries =
            [];

          this.totalRecords =
            0;

          this.isLoading =
            false;

          this.errorMessage =
            'Unable to load enquiry records.';
        }
      });
  }


  // Handle pagination
  onPageChange(
    event: any
  ): void {

    this.pageSize =
      event.rows ||
      10;

    this.firstRecord =
      event.first ||
      0;

    this.pageNo =
      Math.floor(
        this.firstRecord /
        this.pageSize
      ) + 1;

    this.loadEnquiries();
  }


  // Get approval filter
  getApprovalFilterValue():
    boolean | null {

    if (
      this.selectedApprovalStatus ===
      'APPROVED'
    ) {

      return true;
    }

    if (
      this.selectedApprovalStatus ===
      'PENDING'
    ) {

      return false;
    }

    return null;
  }


  // Get active filter
  getActiveFilterValue():
    boolean | null {

    if (
      this.selectedActiveStatus ===
      'ACTIVE'
    ) {

      return true;
    }

    if (
      this.selectedActiveStatus ===
      'INACTIVE'
    ) {

      return false;
    }

    return null;
  }


  // Apply enquiry filters
  applyFilters(): void {

    this.pageNo =
      1;

    this.firstRecord =
      0;

    this.loadEnquiries();
  }


  // Clear enquiry filters
  clearFilters(): void {
    this.selectedEnquiryType = "";
    this.selectedApprovalStatus =
      'ALL';

    this.selectedActiveStatus =
      'ALL';

    this.pageNo =
      1;

    this.firstRecord =
      0;

    this.loadEnquiries();
  }


  // Parse JSON body
  parseBody(
    body: any
  ): any {

    if (!body) {

      return null;
    }

    if (
      typeof body ===
      'object'
    ) {

      return body;
    }

    try {

      return JSON.parse(
        body
      );

    } catch (error) {

      console.error(
        'Unable to parse enquiry body:',
        error
      );

      return null;
    }
  }


  // Get enquiry client type
  getClientType(
    enquiry: any
  ): string {

    return (
      enquiry?.clientType ||
      enquiry?.parsedBody?.clientType ||
      '-'
    )
      .toString()
      .trim()
      .toUpperCase();
  }


  // Check selected enquiry is corporate
  isSelectedEnquiryCorporate(): boolean {

    const clientType =
      (
        this.selectedEnquiry
          ?.clientType ||

        this.selectedEnquiryBody
          ?.clientType ||

        ''
      )
        .toString()
        .trim()
        .toUpperCase();

    return (
      clientType ===
      'CORPORATE'
    );
  }


  // Check selected enquiry is general
  isSelectedEnquiryGeneral(): boolean {

    return (
      !this
        .isSelectedEnquiryCorporate()
    );
  }


  // Get company or course name
  getCompanyName(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.companyName ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.courseTitle ||
      '-'
    );
  }


  // Get requested by name
  getRequestedBy(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.requestedBy ||

        enquiry
          ?.sentBy ||

        '-'
      );
    }

    const givenName =
      enquiry
        ?.parsedBody
        ?.participant
        ?.givenName ||
      '';

    const familyName =
      enquiry
        ?.parsedBody
        ?.participant
        ?.familyName ||
      '';

    const fullName =
      `${givenName} ${familyName}`
        .trim();

    return (
      fullName ||
      enquiry?.sentBy ||
      '-'
    );
  }





  // Get requested by contact
  getRequestedByPhone(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.requestedByPhone ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.participant
        ?.email ||

      enquiry
        ?.sentBy ||

      '-'
    );
  }


  // Get site location
  getSiteLocation(
    enquiry: any
  ): string {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.clientDetails
          ?.siteLocationAddress ||
        '-'
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.occurrence
        ?.location ||
      '-'
    );
  }


  // Get training date
  // Get training date
  getTrainingDate(
    enquiry: any
  ): any {

    return (
      enquiry
        ?.parsedBody
        ?.clientDetails
        ?.dateTrainingRequired ||

      enquiry
        ?.parsedBody
        ?.primaryCourse
        ?.occurrence
        ?.startDate ||

      null
    );
  }


  // Get participant count
  getParticipantCount(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'CORPORATE'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.participants
          ?.length ||
        0
      );
    }

    return (
      enquiry
        ?.parsedBody
        ?.participant
        ? 1
        : 0
    );
  }


  // Get total UOC courses
  getTotalUOC(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'GENERAL'
    ) {

      const primaryCourseCount =
        enquiry
          ?.parsedBody
          ?.primaryCourse
          ?.courseId
          ? 1
          : 0;

      const additionalCount =
        enquiry
          ?.parsedBody
          ?.additionalUOCCourses
          ?.length ||
        0;

      return (
        primaryCourseCount +
        additionalCount
      );
    }

    const participants =
      enquiry
        ?.parsedBody
        ?.participants ||
      [];

    return participants
      .reduce(
        (
          total: number,
          participant: any
        ) => {

          return (
            total +
            (
              participant
                ?.uocCourses
                ?.length ||
              0
            )
          );
        },
        0
      );
  }


  // Get total VOC courses
  getTotalVOC(
    enquiry: any
  ): number {

    const clientType =
      this.getClientType(
        enquiry
      );

    if (
      clientType ===
      'GENERAL'
    ) {

      return (
        enquiry
          ?.parsedBody
          ?.vocCourses
          ?.length ||
        0
      );
    }

    const participants =
      enquiry
        ?.parsedBody
        ?.participants ||
      [];

    return participants
      .reduce(
        (
          total: number,
          participant: any
        ) => {

          return (
            total +
            (
              participant
                ?.vocCourses
                ?.length ||
              0
            )
          );
        },
        0
      );
  }



  // Enquiry type
  EnqType: string = 'Multiple';


  // Open enquiry details
  openEnquiryDetails(enquiry: any): void {

    this.selectedEnquiry = enquiry;

    this.approvalSuccessMessage = '';

    this.approvalErrorMessage = '';


    // =========================================================
    // Parse enquiry body
    // =========================================================
    if (
      enquiry?.parsedBody
    ) {

      this.selectedEnquiryBody =
        enquiry.parsedBody;

    } else {

      this.selectedEnquiryBody =
        this.parseBody(
          enquiry?.body
        );
    }


    if (
      !this.selectedEnquiryBody
    ) {

      this.selectedEnquiryBody =
        {};
    }


    // =========================================================
    // Check New Registration Body Structure
    // =========================================================
    const participantRegistrations =
      this.selectedEnquiryBody
        ?.participantRegistrations;


    if (
      Array.isArray(
        participantRegistrations
      )
      &&
      participantRegistrations.length > 0
    ) {

      let totalUOC =
        0;

      let totalVOC =
        0;


      // =======================================================
      // Count Courses From Participants
      // =======================================================
      participantRegistrations.forEach(
        (participant: any) => {

          totalUOC +=
            participant
              ?.uocCourses
              ?.length
            ?? 0;


          totalVOC +=
            participant
              ?.vocCourses
              ?.length
            ?? 0;

        }
      );


      const totalCourses =
        totalUOC +
        totalVOC;


      this.EnqType =
        totalCourses > 1
          ? 'Multiple'
          : 'Single';


      // =======================================================
      // Map Client Type
      // New structure:
      // enquiryDetails.clientType
      // =======================================================
      if (
        this.selectedEnquiryBody
          ?.enquiryDetails
          ?.clientType
      ) {

        this.selectedEnquiryBody.clientType =
          this.selectedEnquiryBody
            .enquiryDetails
            .clientType;

      }


      // =======================================================
      // Map Company Details
      // =======================================================
      if (
        this.selectedEnquiryBody
          ?.companyDetails
      ) {

        this.selectedEnquiryBody.clientDetails ??=
          {};


        this.selectedEnquiryBody
          .clientDetails
          .companyName =
          this.selectedEnquiryBody
            ?.companyDetails
            ?.companyName
          ?? '';

      }


      // =======================================================
      // If Only One Participant
      // Map Participant For Existing UI
      // =======================================================
      if (
        participantRegistrations.length === 1
      ) {

        const participant =
          participantRegistrations[0];


        this.selectedEnquiryBody.participant ??=
          {};


        this.selectedEnquiryBody
          .participant
          .givenName =
          participant?.firstName
          ?? '';


        this.selectedEnquiryBody
          .participant
          .familyName =
          participant?.lastName
          ?? '';


        this.selectedEnquiryBody
          .participant
          .email =
          participant?.emailAddress
          ?? '';


        this.selectedEnquiryBody
          .participant
          .contactNumber =
          participant?.mobileNumber
          ?? '';


        // =====================================================
        // Primary Course
        // =====================================================
        const firstUOC =
          participant
            ?.uocCourses
          ?.[0];


        const firstVOC =
          participant
            ?.vocCourses
          ?.[0];


        if (firstUOC) {

          this.selectedEnquiryBody.primaryCourse =
          {
            courseId:
              firstUOC?.courseId,

            courseType:
              'UOC',

            courseCode:
              firstUOC?.courseCode,

            courseTitle:
              firstUOC?.courseTitle,

            description:
              firstUOC?.description,

            totalAmount:
              firstUOC?.totalAmount,

            currencyCode:
              firstUOC?.currencyCode,

            documentTypes:
              firstUOC?.documentTypes
          };

        } else if (firstVOC) {

          this.selectedEnquiryBody.primaryCourse =
          {
            courseId:
              firstVOC?.vocId,

            courseType:
              'VOC',

            courseCode:
              firstVOC?.vocCode,

            courseTitle:
              firstVOC?.vocName,

            description:
              firstVOC?.description,

            documentTypes:
              firstVOC?.documentTypes
          };
        }


        // =====================================================
        // Additional UOC Courses
        // =====================================================
        this.selectedEnquiryBody.additionalUOCCourses =
          participant
            ?.uocCourses
            ?.slice(1)
          ?? [];


        // =====================================================
        // VOC Courses
        // =====================================================
        this.selectedEnquiryBody.vocCourses =
          participant
            ?.vocCourses
          ?? [];


        // =====================================================
        // COA Courses
        // =====================================================
        this.selectedEnquiryBody.coaCourses =
          participant
            ?.coaCourses
          ?? [];

      }

    }

    // =========================================================
    // OLD ENQUIRY BODY STRUCTURE
    // =========================================================
    else {

      const uoc =
        this.getTotalUOC(
          enquiry
        );


      const voc =
        this.getTotalVOC(
          enquiry
        );


      const totalCourses =
        uoc +
        voc;


      this.EnqType =
        totalCourses > 1
          ? 'Multiple'
          : 'Single';
    }


    // =========================================================
    // OTHER COURSE ENQUIRY
    // =========================================================
    if (
      this.selectedEnquiryBody
        ?.clientType ===
      'OTHER_COURSE_ENQUIRY'
    ) {

      this.selectedEnquiryBody.additionalComments =
        this.selectedEnquiryBody
          ?.message
        ?? '';


      this.selectedEnquiryBody.participant ??=
        {};


      this.selectedEnquiryBody
        .participant
        .givenName =
        this.selectedEnquiryBody
          ?.contactDetails
          ?.name
        ?? '';


      this.selectedEnquiryBody.primaryCourse ??=
        {};


      this.selectedEnquiryBody
        .primaryCourse
        .description =
        this.selectedEnquiryBody
          ?.message
        ?? '';


      this.selectedEnquiryBody
        .primaryCourse
        .courseTitle =
        this.selectedEnquiryBody
          ?.course
          ?.courseName
        ?? '';
    }


    console.log(
      'Selected Enquiry:',
      this.selectedEnquiry
    );


    console.log(
      'Selected Enquiry Body:',
      this.selectedEnquiryBody
    );


    console.log(
      'Selected Client Type:',
      this.selectedEnquiryBody
        ?.clientType
    );


    console.log(
      'Enquiry Type:',
      this.EnqType
    );


    // =========================================================
    // OTHER COURSE ENQUIRY
    // =========================================================
    if (
      this.selectedEnquiryBody
        ?.clientType ===
      'OTHER_COURSE_ENQUIRY'
    ) {

      this.selectedEnquiryBody.additionalComments =
        this.selectedEnquiryBody
          ?.message
        ?? '';


      this.selectedEnquiryBody.participant ??=
        {};


      this.selectedEnquiryBody
        .participant
        .givenName =
        this.selectedEnquiryBody
          ?.contactDetails
          ?.name
        ?? '';


      this.selectedEnquiryBody
        .participant
        .email =
        this.selectedEnquiryBody
          ?.contactDetails
          ?.email
        ?? '';


      this.selectedEnquiryBody
        .participant
        .contactNumber =
        this.selectedEnquiryBody
          ?.participant
          ?.contactNumber
        ?? this.selectedEnquiryBody
          ?.contactDetails
          ?.telephone
        ?? '';


      this.selectedEnquiryBody.primaryCourse ??=
        {};


      this.selectedEnquiryBody
        .primaryCourse
        .description =
        this.selectedEnquiryBody
          ?.message
        ?? '';


      this.selectedEnquiryBody
        .primaryCourse
        .courseTitle =
        this.selectedEnquiryBody
          ?.course
          ?.courseName
        ?? '';
    }

    // =========================================================
    // Open Modal
    // =========================================================
    this.showDetailsModal =
      true;
  }

  isVocOnlyParticipant(
    participant: any
  ): boolean {

    const uocCount =
      participant
        ?.uocCourses
        ?.length
      ?? 0;

    const vocCount =
      participant
        ?.vocCourses
        ?.length
      ?? 0;

    return (
      vocCount > 0 &&
      uocCount === 0
    );
  }


  // Close enquiry details
  closeEnquiryDetails(): void {

    this.showDetailsModal =
      false;

    this.selectedEnquiry =
      null;

    this.selectedEnquiryBody =
      null;

    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';
  }


  // Approve selected enquiry
  approveSelectedEnquiry(): void {

    if (!this.selectedEnquiry || this.selectedEnquiry.isApproved) {
      return;
    }

    const reviewedBy = 1;

    if (!reviewedBy) {
      this.approvalErrorMessage = 'Logged-in user could not be identified.';
      return;
    }

    this.isApprovingEnquiry =
      true;

    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';

    this.adminService
      .approveXEnquiry(
        this.selectedEnquiry.id,
        reviewedBy, new Date().toString()
      )
      .subscribe({

        next: (
          response: string
        ) => {

          console.log(
            'Approve response:',
            response
          );

          this.isApprovingEnquiry =
            false;

          const result =
            Number(
              response
            );

          if (
            !isNaN(
              result
            ) &&
            result > 0
          ) {

            this.approvalSuccessMessage =
              'Enquiry approved successfully.';

            this.selectedEnquiry
              .isApproved =
              true;

            this.selectedEnquiry
              .reviewedBy =
              reviewedBy;

            this.selectedEnquiry
              .reviewedDate =
              new Date();

            this.loadEnquiries();

            setTimeout(
              () => {

                this
                  .closeEnquiryDetails();
              },
              1000
            );

            return;
          }

          this.approvalErrorMessage =
            'Unable to approve enquiry.';
        },

        error: (error) => {

          console.error(
            'Approve enquiry error:',
            error
          );

          this.isApprovingEnquiry =
            false;

          this.approvalSuccessMessage =
            '';

          this.approvalErrorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to approve enquiry.';
        }
      });
  }





  // Approve selected enquiry
  sendRegistration(): void {

    if (!this.selectedEnquiry) {
      return;
    }

    const reviewedBy = 1;

    if (!reviewedBy) {
      this.approvalErrorMessage = 'Logged-in user could not be identified.';
      return;
    }

    this.isApprovingEnquiry =
      true;

    this.approvalSuccessMessage =
      '';

    this.approvalErrorMessage =
      '';

    this.adminService
      .sendGeneralRegistrationForm(
        this.selectedEnquiry.id,
        reviewedBy, this.approvalTrainingDate
      )
      .subscribe({

        next: (
          response: string
        ) => {

          console.log(
            'Approve response:',
            response
          );

          this.isApprovingEnquiry =
            false;

          const result =
            Number(
              response
            );

          if (
            !isNaN(
              result
            ) &&
            result > 0
          ) {

            this.approvalSuccessMessage =
              'Enquiry approved successfully.';

            this.selectedEnquiry
              .isApproved =
              true;

            this.selectedEnquiry
              .reviewedBy =
              reviewedBy;

            this.selectedEnquiry
              .reviewedDate =
              new Date();

            this.loadEnquiries();

            setTimeout(
              () => {

                this.closeEnquiryDetails();


              },
              1000
            );

            setTimeout(
              () => {

                this.closeApprovalPopup();


              },
              1000
            );



            return;
          }

          this.approvalErrorMessage =
            'Unable to approve enquiry.';
        },

        error: (error) => {

          console.error(
            'Approve enquiry error:',
            error
          );

          this.isApprovingEnquiry =
            false;

          this.approvalSuccessMessage =
            '';

          this.approvalErrorMessage =
            typeof error?.error ===
              'string'
              ? error.error
              : 'Unable to approve enquiry.';
        }
      });
  }


  // Close approval popup
  closeApprovalPopup(): void {

    if (
      this.isApprovingEnquiry
    ) {
      return;
    }


    this.showApprovalPopup = false;

    this.approvalTrainingDate = '';

    this.approvalDateError = '';

    this.approvalErrorMessage = '';
  }





  // Open registration details
  openRegistrationDetails(
    enquiry: any
  ): void {

    const registrationBody =
      enquiry
        ?.parsedRegistrationBody ||

      this.parseBody(
        enquiry
          ?.registrationBody
      );

    if (!registrationBody) {
      return;
    }

    this.selectedRegistrationEnquiry = enquiry;

    this.selectedRegistration = registrationBody;

    this.showRegistrationModal = true;
  }


  // Close registration details
  closeRegistrationDetails(): void {

    this.showRegistrationModal =
      false;

    this.selectedRegistration =
      null;

    this.selectedRegistrationEnquiry =
      null;
  }


  // Get safe document URL
  getSafeDocumentUrl(
    url: string
  ): SafeResourceUrl {

    return this.sanitizer
      .bypassSecurityTrustResourceUrl(
        url
      );
  }


  // Check document is image
  isImageFile(
    fileType: string,
    fileName: string
  ): boolean {

    const type =
      (
        fileType ||
        ''
      )
        .toLowerCase();

    const name =
      (
        fileName ||
        ''
      )
        .toLowerCase();

    return (
      type.startsWith(
        'image/'
      ) ||

      name.endsWith(
        '.jpg'
      ) ||

      name.endsWith(
        '.jpeg'
      ) ||

      name.endsWith(
        '.png'
      ) ||

      name.endsWith(
        '.webp'
      )
    );
  }


  // Check document is PDF
  isPdfFile(
    fileType: string,
    fileName: string
  ): boolean {

    const type =
      (
        fileType ||
        ''
      )
        .toLowerCase();

    const name =
      (
        fileName ||
        ''
      )
        .toLowerCase();

    return (
      type ===
      'application/pdf' ||

      name.endsWith(
        '.pdf'
      )
    );
  }




  // ============================================================
  // DOCUMENT PREVIEW SETTINGS
  // ============================================================

  documentPreviewSettings = {

    certificate: {
      width: 0,
      height: 300
    },

    identity: {
      width: 0,
      height: 100
    }

  };


  // ============================================================
  // GET IMAGE PREVIEW STYLE
  // ============================================================

  getDocumentImageStyle(
    type: 'certificate' | 'identity'
  ): { [key: string]: string } {

    const settings =
      this.documentPreviewSettings[type];

    const width =
      settings.width ?? 0;

    const height =
      settings.height ?? 0;


    const style: { [key: string]: string } = {

      display: 'block',

      'object-fit': 'contain',

      // IMPORTANT:
      // Keep actual image at top-left.
      'object-position': 'left top',

      margin: '0'
    };


    // ==========================================================
    // WIDTH > 0 && HEIGHT > 0
    //
    // Fixed box.
    // Image remains proportional using object-fit.
    // ==========================================================

    if (
      width > 0 &&
      height > 0
    ) {

      style['width'] =
        `${width}px`;

      style['height'] =
        `${height}px`;

      return style;
    }


    // ==========================================================
    // WIDTH > 0 && HEIGHT = 0
    //
    // Fixed width.
    // Height automatically follows image aspect ratio.
    // ==========================================================

    if (
      width > 0 &&
      height <= 0
    ) {

      style['width'] =
        `${width}px`;

      style['height'] =
        'auto';

      return style;
    }


    // ==========================================================
    // WIDTH = 0 && HEIGHT > 0
    //
    // Fixed height.
    // Width automatically follows image aspect ratio.
    // ==========================================================

    if (
      width <= 0 &&
      height > 0
    ) {

      style['width'] =
        'auto';

      style['height'] =
        `${height}px`;

      return style;
    }


    // ==========================================================
    // WIDTH = 0 && HEIGHT = 0
    //
    // Full available width.
    // Automatic height.
    // ==========================================================

    style['width'] =
      '100%';

    style['height'] =
      'auto';

    return style;
  }


  // ============================================================
  // GET PDF PREVIEW STYLE
  // ============================================================

  getDocumentPdfStyle(
    type: 'certificate' | 'identity'
  ): { [key: string]: string } {

    const settings =
      this.documentPreviewSettings[type];

    const width =
      settings.width ?? 0;

    const height =
      settings.height ?? 0;


    return {

      display: 'block',

      width:
        width > 0
          ? `${width}px`
          : '100%',

      height:
        height > 0
          ? `${height}px`
          : '600px',

      border: '0',

      margin: '0'
    };
  }


  isSignatureImage(
    signature: string | null | undefined
  ): boolean {

    if (!signature) {
      return false;
    }


    return (
      signature.startsWith(
        'data:image/'
      ) ||
      signature.startsWith(
        'http://'
      ) ||
      signature.startsWith(
        'https://'
      )
    );

  }


  getIdentityTypeLabel(idType: string | null | undefined): string {

    switch (idType) {

      case 'DRIVER_LICENCE':
        return 'Driver Licence';

      case 'PASSPORT':
        return 'Passport';

      case 'PROOF_OF_AGE':
        return 'Proof of Age';

      case 'OTHER':
        return 'Other';

      default:
        return idType || '-';
    }
  }



  // Approval popup
  showApprovalPopup = false;

  approvalTrainingDate: string = '';

  approvalDateError: string = '';
  // Open approval confirmation popup
  openApprovalPopup(): void {




    this.approvalErrorMessage = '';
    this.approvalDateError = '';


    // Get current training required date
    const currentTrainingDate = new Date();


    // Convert date to yyyy-MM-dd for HTML date input
    this.approvalTrainingDate =
      this.formatDateForInput(
        currentTrainingDate
      );


    this.showApprovalPopup = true;
  }



  // Convert API date to HTML date input format
  formatDateForInput(
    value: string | Date | null | undefined
  ): string {

    if (!value) {
      return '';
    }


    // API already returns yyyy-MM-dd...
    if (
      typeof value === 'string' &&
      /^\d{4}-\d{2}-\d{2}/.test(value)
    ) {

      return value.substring(
        0,
        10
      );
    }


    const date =
      new Date(value);


    if (
      isNaN(
        date.getTime()
      )
    ) {

      return '';
    }


    const year =
      date.getFullYear();

    const month =
      String(
        date.getMonth() + 1
      )
        .padStart(
          2,
          '0'
        );

    const day =
      String(
        date.getDate()
      )
        .padStart(
          2,
          '0'
        );


    return `${year}-${month}-${day}`;
  }



  
// ============================================================
// PAGINATION
// ============================================================

// Get total number of pages
get totalPages(): number {

  return Math.max(
    1,
    Math.ceil(
      this.totalRecords / this.pageSize
    )
  );

}


// Generate page numbers
get pageNumbers(): number[] {

  return Array.from(
    { length: this.totalPages },
    (_, index) => index + 1
  );

}


// Get first displayed record
get startRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return this.firstRecord + 1;

}


// Get last displayed record
get endRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return Math.min(
    this.firstRecord + this.enquiries.length,
    this.totalRecords
  );

}


// Change current page
changePage(page: number): void {

  if (
    !Number.isInteger(page) ||
    page < 1 ||
    page > this.totalPages ||
    this.isLoading
  ) {
    return;
  }

  if (this.pageNo === page) {
    return;
  }

  this.pageNo = page;

  this.firstRecord =
    (this.pageNo - 1) * this.pageSize;

  this.loadEnquiries();

}


// Previous page
previousPage(): void {

  this.changePage(
    this.pageNo - 1
  );

}


// Next page
nextPage(): void {

  this.changePage(
    this.pageNo + 1
  );

}


// Change rows per page
onPageSizeChange(): void {

  this.pageNo = 1;

  this.firstRecord = 0;

  this.loadEnquiries();

}


}


